@if (form) {
  <div class="content" [formGroup]="form">
    <h2 trans="user_details_dialog.title">(title)</h2>
    <p trans="user_details_dialog.p1"></p>
    <p trans="user_details_dialog.p2.phone"></p>
    <a class="active-link" trans="user_details_dialog.a" routerLink="/help/faq" (click)="onCancel()">(link)</a>
    @if (phoneInput) {
      <nom-phone-input
        name="{{i18n.getPhrase('nomidio.phone.number')}}"
        [control]="phoneInput"
        [errors]="errors.textInputErrors()"
      ></nom-phone-input>
    }
    <div class="button-group">
      <button
        id="dialog-button-2"
        class="btn btn-secondary"
        type="button"
        trans="user_details_dialog.cancel"
        (click)="onCancel()"
      ></button>
      <button
        id="dialog-button-1"
        class="btn btn-primary"
        type="submit"
        trans="user_details_dialog.confirm"
        [disabled]="form.invalid"
        (click)="onSubmit()"
      ></button>
    </div>
  </div>
}
